export default __webpack_public_path__ + "static/media/medium.73a49efa.svg";